import Tooltip from "@mui/material/Tooltip";

const CustomTooltip = ({ title, children }) => {
  return (
    <Tooltip title={title} arrow placement="top">
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
